import { preview, features } from './preview';
import { jobsite } from './builder';
import { OneClickConfig } from '../../../../models/one-click-config.model';
import { ShippingLocationModeCode } from '../../../../models/shipping-location-mode.model';

export const delivery: OneClickConfig = {
  preview: preview,
  builder: {
    [ShippingLocationModeCode.Jobsite]: jobsite,
  },
  features: features,
};
